<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 16L9.77612 12.0014L14 8" stroke="#6A7285" stroke-width="1.5" stroke-miterlimit="10"/>
</svg>
